import { Button } from '../components/Button';
import { Body, Screen, ScreenBody, Title } from '../components/Screen';
import { copy } from '../copy';
import { env } from '../config/env';
import type { AppConfig } from '../config';

/**
 * Shared. The camera did not start, or the AR module failed to load.
 *
 * One honest screen with one action. The underlying message is shown only when
 * the dev HUD is on — a guest does not need to read a DOMException, but the
 * person holding the kiosk at 9pm does.
 */
export function ErrorScreen({
  config,
  error,
  onRetry,
}: {
  config: AppConfig;
  error: Error | null;
  onRetry: () => void;
}) {
  const kiosk = config.mode === 'kiosk';
  return (
    <Screen kiosk={kiosk}>
      <div className="pt-12" />
      <ScreenBody>
        <Title kiosk={kiosk}>{copy.error.heading}</Title>
        <Body kiosk={kiosk}>{copy.error.body}</Body>
        {env.devHud && error ? (
          <p className="max-w-md font-mono text-xs text-blood" data-selectable>
            {error.message}
          </p>
        ) : null}
      </ScreenBody>
      <div className={`w-full pb-4 ${kiosk ? 'max-w-xl' : 'max-w-sm'}`}>
        <Button kiosk={kiosk} onClick={onRetry}>
          {copy.error.cta}
        </Button>
      </div>
    </Screen>
  );
}
